'use strict';

const addOrRemove = (array, item) => {
    const exists = array.includes(item);
    if (exists) {
        return array.filter(c => c !== item);
    }
    else {
        return [...array, item];
    }
};
const objectKeyExistInArray = (array, item, getItemKey) => {
    let exists = false;
    for (const obj of array) {
        if (getItemKey(obj) === getItemKey(item)) {
            exists = true;
            break;
        }
    }
    return exists;
};
const removeObjectKeyFromArray = (array, item, getItemKey) => {
    const exists = objectKeyExistInArray(array, item, getItemKey);
    if (exists) {
        return array.filter(c => getItemKey(c) !== getItemKey(item));
    }
    return array;
};

exports.addOrRemove = addOrRemove;
exports.objectKeyExistInArray = objectKeyExistInArray;
exports.removeObjectKeyFromArray = removeObjectKeyFromArray;
//# sourceMappingURL=array.js.map
